import { graphql, useStaticQuery } from 'gatsby';

export default function useSitemap() {
  const data = useStaticQuery(graphql`
    query siteMapQuery{
      allSitePage {
        edges {
          node {
            path
          }
        }
      }
    }
  `);
  return data.allSitePage.edges.map(({ node }) => node.path);
}
